<sv-toolbar-time class="w-[420px]"></sv-toolbar-time>
<div class="flex-1"></div>
<img class="brand" src="/assets/smc-logo-white.png" />
<div class="flex-1"></div>

<span class="ads-placeholder">Marquee Ad Space</span>
